import { render, staticRenderFns } from "./origin.vue?vue&type=template&id=20bb2202&scoped=true&"
import script from "./origin.vue?vue&type=script&lang=js&"
export * from "./origin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bb2202",
  null
  
)

export default component.exports